import { joinURL } from 'ufo';
import { useAppConfig } from '#app/config';
import { useRuntimeConfig } from '#app/nuxt';

export function useWorkspaceApiBaseUrl(): string {
	const runtimeConfig = useRuntimeConfig();
	const appConfig = useAppConfig();

	if (!appConfig.monospace.workspaceSlug) throw new Error('No workspace selected');

	return joinURL(runtimeConfig.public.api, appConfig.monospace.workspaceSlug);
}
